/**
 * Fly Bundles may inject via app embed outside variant-selects.
 * Move the bundle widget inside variant-selects, after size/logo steps
 * (Colour → Size → Logo → Bundle). Hide the in-widget £10-off promo
 * (that copy now lives above size). Keep widget events from hijacking
 * the product colour picker.
 */
(function () {
  var BUNDLE_SELECTOR =
    '[class*="gfbVolumeBundleTemplate_"], [class*="gfbVolumeDiscountWidgetOfferContainer"]';
  var ANCHOR_SELECTOR =
    '[data-size-option], .variant-picker-step__premium-separate, [data-logo-option], .product-form__logo-option';

  function getLastAnchorStep(variantSelects) {
    var last = null;
    variantSelects.querySelectorAll(ANCHOR_SELECTOR).forEach(function (el) {
      last = el.closest('.variant-picker-step') || el;
    });
    return last;
  }

  function isHiddenPicker(node) {
    var picker = node && node.closest ? node.closest('variant-selects') : null;
    if (!picker) return false;
    if (picker.style.display === 'none') return true;
    return picker.getAttribute('aria-hidden') === 'true';
  }

  function findBundleRoots(productInfo) {
    var seen = new Set();
    var roots = [];

    productInfo.querySelectorAll(BUNDLE_SELECTOR).forEach(function (node) {
      var root =
        node.closest('[class*="gfbPageWrapper"]') ||
        node.closest('[class*="gfbVolumeBundleTemplate_"]') ||
        node;
      if (!root || seen.has(root)) return;
      if (root.closest('[data-evertee-bundle-parking]')) return;
      if (root.getAttribute('data-evertee-duplicate-bundle') === 'true') return;
      if (isHiddenPicker(root)) return;
      seen.add(root);
      roots.push(root);
    });

    return roots;
  }

  function getNodesToMove(bundle) {
    var root =
      bundle.closest('[class*="gfbPageWrapper"]') ||
      bundle.closest('[class*="gfbVolumeBundleTemplate_"]') ||
      bundle;
    return [root];
  }

  function insertNodesAfter(parent, referenceNode, nodes) {
    var ref = referenceNode.nextSibling;
    nodes.forEach(function (node) {
      parent.insertBefore(node, ref);
    });
  }

  function isBundlePromoText(text) {
    var compact = String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!compact || compact.length > 90) return false;
    return /all bundles/i.test(compact) && /10\s*off/i.test(compact);
  }

  function hideInlineBundlePromo(productInfo) {
    var keep = productInfo.querySelector('.product__bundle-offer');
    productInfo.querySelectorAll('[class*="gfb"]').forEach(function (el) {
      if (keep && (el === keep || keep.contains(el))) return;
      if (el.querySelector && el.querySelector('[class*="gfbVolumeDiscountWidgetOffer"]')) return;
      if (!isBundlePromoText(el.textContent)) return;
      if (el.children.length > 6) return;
      if (el.style.display === 'none') return;
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });
  }

  var HIDDEN_BUNDLE_SWATCH_HEXES = ['aebdef', 'bd8fa7', 'efe5cc'];

  function normalizeHex(value) {
    return String(value || '')
      .replace(/[^0-9a-f]/gi, '')
      .toLowerCase();
  }

  function getSwatchCustomHex(el) {
    if (!el) return '';
    var inline = el.getAttribute('style') || '';
    var match = inline.match(/--custom-swatch-color:\s*(#[0-9a-fA-F]{3,8})/i);
    if (match) return normalizeHex(match[1]);
    var computed = window.getComputedStyle(el).getPropertyValue('--custom-swatch-color');
    return normalizeHex(computed);
  }

  function hideBundleSwatchesByHex(productInfo) {
    var roots = findBundleRoots(productInfo);
    if (!roots.length) {
      var fallback =
        productInfo.querySelector('[class*="gfbPageWrapper"]') ||
        productInfo.querySelector('[class*="gfbVolumeBundleTemplate_"]');
      if (fallback) roots = [fallback];
    }

    roots.forEach(function (root) {
      root.querySelectorAll('.gfbVolumeDiscountSwatchContainer .gfbVolumeDiscountSwatchColorUI').forEach(function (swatch) {
        var hex = getSwatchCustomHex(swatch);
        if (HIDDEN_BUNDLE_SWATCH_HEXES.indexOf(hex) === -1) return;
        if (swatch.getAttribute('data-evertee-hidden-swatch') === 'true') return;
        swatch.style.display = 'none';
        swatch.setAttribute('aria-hidden', 'true');
        swatch.setAttribute('data-evertee-hidden-swatch', 'true');
      });
    });
  }

  function isolateBundleEvents(bundle) {
    if (!bundle || bundle.dataset.gfbEventsIsolated) return;
    bundle.dataset.gfbEventsIsolated = 'true';
    bundle.addEventListener('change', function (event) {
      event.stopPropagation();
    });
    bundle.addEventListener('input', function (event) {
      event.stopPropagation();
    });
  }

  function scoreBundle(bundle, variantSelects) {
    var score = 0;
    if (bundle.offsetParent !== null) score += 20;
    if (variantSelects && variantSelects.contains(bundle)) score += 8;
    score += bundle.querySelectorAll('[class*="gfbVolumeDiscountWidgetOffer"]').length * 6;
    score += Math.min(bundle.querySelectorAll('*').length, 80) / 8;
    return score;
  }

  function pickPrimaryBundle(bundles, variantSelects) {
    var best = bundles[0];
    var bestScore = -1;
    bundles.forEach(function (bundle, index) {
      var score = scoreBundle(bundle, variantSelects) + index * 0.01;
      if (score >= bestScore) {
        bestScore = score;
        best = bundle;
      }
    });
    return best;
  }

  function hideDuplicateBundles(bundles, keep) {
    bundles.forEach(function (bundle) {
      if (bundle === keep) return;
      if (keep.contains(bundle) || bundle.contains(keep)) return;
      bundle.style.display = 'none';
      bundle.setAttribute('aria-hidden', 'true');
      bundle.setAttribute('data-evertee-duplicate-bundle', 'true');
    });
  }

  function repositionBundlesInProductInfo(productInfo) {
    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return;

    var lastAnchor = getLastAnchorStep(variantSelects);
    if (!lastAnchor) return;

    var bundles = findBundleRoots(productInfo).filter(function (bundle) {
      return bundle.getAttribute('data-evertee-duplicate-bundle') !== 'true';
    });
    if (!bundles.length) {
      bundles = findBundleRoots(productInfo);
    }
    if (!bundles.length) return;

    var keep = pickPrimaryBundle(bundles, variantSelects);
    hideDuplicateBundles(bundles, keep);

    var nodesToMove = getNodesToMove(keep);
    var firstNode = nodesToMove[0];
    if (!firstNode) return;

    var outsideSelects = nodesToMove.some(function (node) {
      return node.parentElement !== variantSelects;
    });
    var bundleBeforeAnchors =
      firstNode.parentElement === variantSelects &&
      !!(firstNode.compareDocumentPosition(lastAnchor) & Node.DOCUMENT_POSITION_FOLLOWING);

    if (!outsideSelects && !bundleBeforeAnchors) return;

    insertNodesAfter(variantSelects, lastAnchor, nodesToMove);
  }

  function enhanceProductInfo(productInfo) {
    if (productInfo.dataset.bundleEnhanceLock) return;
    productInfo.dataset.bundleEnhanceLock = 'true';
    try {
      repositionBundlesInProductInfo(productInfo);
      hideInlineBundlePromo(productInfo);
      isolateBundleEvents(
        productInfo.querySelector('[class*="gfbPageWrapper"]') ||
          productInfo.querySelector('[class*="gfbVolumeBundleTemplate_"]')
      );
      hideBundleSwatchesByHex(productInfo);
    } finally {
      window.setTimeout(function () {
        delete productInfo.dataset.bundleEnhanceLock;
      }, 80);
    }
  }

  function enhanceAll() {
    document.querySelectorAll('.product__info-container, .product__info-wrapper').forEach(enhanceProductInfo);
  }

  function observeProductInfo() {
    document.querySelectorAll('.product__info-container, .product__info-wrapper').forEach(function (productInfo) {
      if (productInfo.dataset.bundleLayoutObserved) return;
      productInfo.dataset.bundleLayoutObserved = 'true';

      var observer = new MutationObserver(function () {
        if (productInfo._bundleEnhanceTimer) clearTimeout(productInfo._bundleEnhanceTimer);
        productInfo._bundleEnhanceTimer = window.setTimeout(function () {
          productInfo._bundleEnhanceTimer = null;
          enhanceProductInfo(productInfo);
        }, 120);
      });
      observer.observe(productInfo, { childList: true, subtree: true });
    });
  }

  function init() {
    enhanceAll();
    observeProductInfo();
    window.setTimeout(enhanceAll, 400);
    window.setTimeout(enhanceAll, 1600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
